<script>
  export let icon = "edit.svg";
  export let title = "Action";
  export let danger = false;
  export let disabled = false;

  let buttonElement;
  let tooltipVisible = false;
  let tooltipX = 0;
  let tooltipY = 0;

  function showTooltip() {
    const rect = buttonElement?.getBoundingClientRect();
    if (!rect) return;
    tooltipX = rect.left + rect.width / 2;
    tooltipY = rect.top - .5 * 16;
    tooltipVisible = true;
  }
</script>

<button
  class="paxbot-table-action-button"
  class:danger
  type="button"
  {title}
  {disabled}
  aria-label={title}
  bind:this={buttonElement}
  on:click
  on:mouseenter={showTooltip}
  on:mouseleave={() => (tooltipVisible = false)}
  on:focus={showTooltip}
  on:blur={() => (tooltipVisible = false)}
>
  <img src={`/img/assistant/icons/${icon}`} alt="" />
  <span
    class="action-tooltip"
    class:visible={tooltipVisible}
    style={`left: ${tooltipX}px; top: ${tooltipY}px;`}
  >{title}</span>
</button>

<style>
  .paxbot-table-action-button {
    display: grid;
    width: 2rem;
    height: 2rem;
    place-items: center;
    padding: 0;
    border: 0;
    border-radius: 100%;
    background: var(--pax-white-new);
    cursor: pointer;
  }

  .paxbot-table-action-button:hover {
    background: var(--pax-grey-new);
  }

  .action-tooltip {
    position: fixed;
    z-index: 40000;
    width: max-content;
    max-width: 12rem;
    padding: .4rem .55rem;
    border-radius: .35rem;
    background: var(--pax-black);
    color: var(--pax-white);
    font-size: .75rem;
    font-weight: 400;
    line-height: 1.2;
    pointer-events: none;
    opacity: 0;
    transform: translate(-50%, -100%);
    transition: opacity .15s ease;
  }

  .action-tooltip.visible {
    opacity: 1;
  }

  .paxbot-table-action-button:disabled {
    cursor: not-allowed;
    opacity: .45;
  }

  .paxbot-table-action-button:disabled:hover {
    background: var(--pax-white-new);
  }

  .paxbot-table-action-button.danger:hover {
    background: var(--pax-state-danger-new);
  }

  .paxbot-table-action-button img {
    width: 1.1rem;
    height: 1.1rem;
    filter: brightness(0);
  }
</style>
